import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleriaComponent } from './galleria.component';

@NgModule({
    declarations: [
        GalleriaComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        GalleriaComponent
    ]
})
export class NcGalleriaModule { }